module.exports = __webpack_public_path__ + "img/filter-type-yoga.d5318e11.svg";